export const StoriesStyle = {
    background: '#2ababe',
    flexDirection: 'column',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& .styles_main__-0FEu': {
        background: '#2ababe',
    },
    '& .CustomComponents-styles_component__w87Wx': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    '& .ProgressBar-styles_bar__x0O50': {
        backgroundColor: '#f0f0f0',
    },
    '& .MuiDialog-container': {
        width: '100%',
    },
    '& .MuiAppBar-root': {
        alignItems: 'flex-end',
        boxShadow: 'none',
        backgroundColor: '#2ababe',
    },
    '& .MuiDialogContent-root': {
        padding: '0',
    },
    '& .MuiDialogTitle-root': {
        background: '#2ababe',
    },
    '& .MuiDialog-paper': {
        maxWidth: 'none',
    },
    '& .MuiIconButton-root': {
        color: '#f0f0f0',
    },
};
